import React, { useEffect, useState } from "react";
import { useSnapshot } from "valtio";
import { state } from "../client/store";

const LoginPopUp = () => {
  const snap = useSnapshot(state);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const validateInput = () => {
    var mailReg = /\S+@\S+\.\S+/;
    var pass = password.length >= 8 ? true : false;

    console.log("MAIL: ", mailReg, "  PASSWORD: ", pass);
    if (mailReg.test(email) && pass) {
      return true;
    }

    return false;
  };

  const handleLogin = () => {
    alert("Login CLicked");
  };

  return (
    <>
      <div className="bg-black/[.50] fixed top-0 right-0 left-0 z-50 w-full md:inset-0 h-modal h-full flex justify-center items-center">
        <div className="relative p-4 w-full max-w-md  md:h-auto">
          {/* <!-- Modal content --> */}
          <div className="relative bg-white rounded-lg shadow ">
            <button
              onClick={() => {
                state.loginModal = false;
              }}
              type="button"
              className="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center "
              data-modal-toggle="authentication-modal"
            >
              <svg
                aria-hidden="true"
                className="w-5 h-5"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clipRule="evenodd"
                ></path>
              </svg>
              <span className="sr-only">Close modal</span>
            </button>
            <div className="py-6 px-6 lg:px-8">
              <h3 className="mb-4 text-xl font-medium text-gray-900 ">
                Sign in to our platform
              </h3>
              <form className="space-y-6" action="#" onSubmit={handleLogin}>
                <div>
                  <label
                    htmlFor="email"
                    className="block mb-1 text-sm font-medium text-gray-900 "
                  >
                    Your email
                  </label>
                  <input
                    value={email}
                    onChange={(e) => {
                      setEmail(e.target.value);
                    }}
                    type="email"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  "
                    placeholder="name@company.com"
                    required
                  />
                </div>
                <div>
                  <label className="block mb-1 text-sm font-medium text-gray-900 ">
                    Your password
                  </label>
                  <input
                    value={password}
                    onChange={(e) => {
                      setPassword(e.target.value);
                    }}
                    type="password"
                    autoComplete="current-password"
                    placeholder="••••••••"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  "
                    required
                  />
                </div>
                <div className="flex flex-col justify-between">
                  <span className="w-full mb-2 text-red-700 text-center">
                    {snap.errorMsg}
                  </span>
                  <a
                    href="#"
                    className="text-sm text-blue-700 hover:underline "
                  >
                    Lost Password?
                  </a>
                </div>
                <button
                  type="submit"
                  className="w-full text-yellow-400 hover:text-white bg-black  focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center "
                >
                  Login as Reseller
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoginPopUp;
